<div class="filterable-list custom-mat-form-wrapper">
  <mat-form-field appearance="fill" class="w-full" subscriptSizing="dynamic" (click)="$event.stopPropagation()">
    <input
      autocomplete="off"
      matInput
      tabindex="-1"
      #searchInput
      [formControl]="gitBranchNameFC"
      data-test="input-git-branch-filter"
      [placeholder]="label"
    />
    <div matPrefix>
      <ng-content select="[prefix]"></ng-content>
    </div>
    <div matSuffix *ngIf="(gitBranchNameFC.value?.length || 0) > 0" class="relative">
      <button
        class="custom-button-icon-small"
        mat-icon-button
        (focusin)="$event.stopPropagation()"
        (click)="clear(); preventFocusOnClear && $event.stopPropagation()"
      >
        <fa-icon [icon]="['fal', 'times']"></fa-icon>
      </button>
    </div>
  </mat-form-field>
</div>
